import { Button } from "@mui/material";
import BazarImage from "components/BazarImage";
import { FlexBox } from "components/flex-box";
import Link from "next/link";
import { useRouter } from "next/router";
import React from "react";
import { H1 } from "./Typography";
import { navigationRoutes } from "common/constants/navigation-routes";

const PageDisableComponent = () => {
  const router = useRouter();

  const handleGoBack = async () => {
    router.back();
  };

  return (
    <FlexBox
      flexDirection="column"
      minHeight="100vh"
      justifyContent="center"
      alignItems="center"
      px={2}
    >
      <BazarImage
        src="/assets/images/kachi/kachi-nervous.png"
        sx={{
          display: "block",
          maxWidth: "320px",
          width: "100%",
          mb: "1.5rem",
        }}
      />
      <FlexBox flexWrap="wrap" flexDirection={"column"} textAlign={"center"}>
        <H1>This page is currently unavailable</H1>
        <Button
          variant="outlined"
          color="primary"
          sx={{ m: "0.5rem" }}
          onClick={handleGoBack}
        >
          Go Back
        </Button>
        <Link href={navigationRoutes.homepage} passHref>
          <Button variant="contained" color="primary" sx={{ m: "0.5rem" }}>
            Go to Home
          </Button>
        </Link>
      </FlexBox>
    </FlexBox>
  );
};

export default PageDisableComponent;
